import { makeObservable, observable, runInAction } from "mobx"
import API from "../api/API"
import Wochenbrief from "../api/model/Wochenbrief"
import RootStore from "./RootStore"
import Store from "./Store"

class WochenbriefStore extends Store {
  @observable letter: Wochenbrief | null = null
  @observable loadingFailed = false

  constructor(root: RootStore) {
    super(root)
    makeObservable(this)
  }

  public async load() {
    try {
      const letter = await API.Wochenbrief.currentLetter()
      runInAction(() => {
        this.letter = letter
        this.loadingFailed = false
        this.rootStore.configurationStore.log("Updated wochenbrief")
      })
    } catch (error) {
      runInAction(() => {
        this.loadingFailed = true
      })
      this.rootStore.configurationStore.log(
        "Could not load wochenbrief: " + (error as Error).message,
      )
      console.log(error)
    }
  }
}

export default WochenbriefStore
